import { formatINR } from "../../lib/format";
import { cn as classJoin } from "../../lib/utils";

export default function LeaderboardTable({ title, icon, rows, keyHeader, renderKey, testid }) {
    return (
        <div className="reedos-card overflow-hidden" data-testid={testid}>
            <div className="px-5 py-3 border-b border-slate-200">
                <div className="reedos-eyebrow flex items-center gap-1.5">{icon} {title}</div>
            </div>
            {rows.length === 0 ? (
                <div className="px-5 py-6 text-center text-xs text-slate-500">No data in this filter.</div>
            ) : (
                <table className="w-full text-sm">
                    <thead className="bg-slate-50 border-b border-slate-200">
                        <tr className="text-left">
                            <th className="px-4 py-2 reedos-eyebrow text-[9px]">{keyHeader}</th>
                            <th className="px-4 py-2 reedos-eyebrow text-[9px] text-right">Proposals</th>
                            <th className="px-4 py-2 reedos-eyebrow text-[9px] text-right">PO finalized</th>
                            <th className="px-4 py-2 reedos-eyebrow text-[9px] text-right">Paid</th>
                            <th className="px-4 py-2 reedos-eyebrow text-[9px] text-right">Conversion</th>
                            <th className="px-4 py-2 reedos-eyebrow text-[9px] text-right">Value</th>
                            <th className="px-4 py-2 reedos-eyebrow text-[9px] text-right">Outstanding</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r) => (
                            <tr key={r.key} className="border-t border-slate-100 reedos-row-hover">
                                <td className="px-4 py-2 text-xs">{renderKey(r)}</td>
                                <td className="px-4 py-2 text-xs text-right reedos-data">{r.proposals}</td>
                                <td className="px-4 py-2 text-xs text-right reedos-data">{r.po_finalized}</td>
                                <td className="px-4 py-2 text-xs text-right reedos-data text-emerald-700 font-semibold">{r.paid}</td>
                                <td className="px-4 py-2 text-xs text-right reedos-data">
                                    <span className={classJoin("inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-bold border",
                                        r.conversion_pct >= 50 ? "bg-emerald-50 text-emerald-700 border-emerald-200" :
                                            r.conversion_pct >= 25 ? "bg-amber-50 text-amber-700 border-amber-200" :
                                                "bg-rose-50 text-rose-700 border-rose-200")}>
                                        {r.conversion_pct}%
                                    </span>
                                </td>
                                <td className="px-4 py-2 text-xs text-right reedos-data font-semibold">{formatINR(r.value)}</td>
                                <td className="px-4 py-2 text-xs text-right reedos-data text-rose-700">{r.outstanding > 0 ? formatINR(r.outstanding) : "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
